import { render } from "./actualizacionesDetalle.vue?vue&type=template&id=4b3ad714&scoped=true"
import script from "./actualizacionesDetalle.vue?vue&type=script&lang=js"
export * from "./actualizacionesDetalle.vue?vue&type=script&lang=js"

import "./actualizacionesDetalle.vue?vue&type=style&index=0&id=4b3ad714&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b3ad714"]])

export default __exports__